import {Component} from '@angular/core';

@Component({
  selector: 'call-ico',
  templateUrl: './call-ico.component.html'
})
export class CallIcoComponent {
}
